<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Site list"
          text=""
          class="elevation-1"
        >
          <!--v-btn
            color="pink"
            style="margin-right:10px"
            dark
            small
            absolute
            top
            right
            @click="upsertDialog()"
            v-if="$can('upsert', 'site')"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn-->

          <v-data-table
            id="site_dataTable"
            :headers="headers"
            :items="sites"
            :pagination.sync="pagination"
            :total-items="totalSites"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
          >
            <v-progress-linear
              v-slot:progress
              color="primary"
              indeterminate
            ></v-progress-linear>

            <!--template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-dark text-success text-darken-3"
                v-text="header.text"
              />
            </template-->

            <template slot="headers" slot-scope="props">
              <tr>
                <th 
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === pagination.sortBy &&
                    header.sortable != false ? 'active' : ''
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>mdi-menu-down</v-icon>
                  <span 
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  />
                </th>
              </tr>
              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">

                   <div v-if="filters.hasOwnProperty(header.value)" >
                    <v-text-field
                      clearable
                      md4
                      v-if="filters[header.value].type == 'text'"
                      v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder"
                      @input="filterChanged(filters[header.value])"
                    />

                    <v-select
                      clearable
                      md4
                      v-if="filters[header.value].type == 'list'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-select>

                    <v-autocomplete
                      clearable
                      md4
                      v-if="filters[header.value].type == 'autocomplete'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-autocomplete>
                  </div>

                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
             
              <td class="text-xs-left">{{ item.name }}</td>
              <td class="text-xs-left">{{ item.country_code }}</td>
              <td class="text-xs-left">{{ item.city }}</td>
              <td class="text-xs-left">{{ item.code }}</td>

              <td class="text-xs-right">
                <v-tooltip top>
                  <template slot="activator" slot-scope="{ on }">
                    <a flat @click="openAuditTrail(item)" class="ml-2">
                      <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                    </a>
                  </template>
                  <span>Audit Trail</span>
                </v-tooltip>
              </td>
                  <!--td class="text-xs-center">
                <v-tooltip top>
                  <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertDialog(item)">
                        <v-icon v-if="$can('upsert', 'site')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'site')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                  </template>
                  <span>Site Details</span>
                </v-tooltip>

                  &nbsp;&nbsp;&nbsp;&nbsp;

                <v-tooltip top v-if="$can('delete', 'site')">
                  <template slot="activator" slot-scope="{ on }">
                    <a flat @click="siteItem = item; deleteDialog = true">
                      <v-icon v-if="$can('delete', 'site')" v-on="on" color="primary">mdi-delete-forever</v-icon>
                    </a>
                  </template>
                  <span>Remove Site</span>
                </v-tooltip>

              
              </td-->
            </template>
          </v-data-table>
        </material-card>

      </v-flex>
    </v-layout>

    <safety-delete-modal v-model="deleteDialog" entity="Site" :entityId="siteItem.name" @confirm="confirmDelete"/>
    <v-dialog v-model="auditTrail.open" width="1200px">
      <safety-audittrail-timeline v-if='auditTrail.open' entity="site" :entity_id='auditTrail.entityId' :fields="headers"/>
    </v-dialog>    

  </v-container>
</template>



<script>
import { getList, remove } from "@/api/site";
import { normalizeFilters } from "@/utils/filters";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 5,
        page: 1,
        sortBy: 'id',
        descending: true,
        totalItems:undefined
      },
      auditTrail: {
        open: false,
        entityId: null
      },
      siteItem: {},
      deleteDialog: false,
      rowsPerPageItems: [5,10,25],
      loading: true,
      totalSites: 0,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Country",
          align: "left",
          sortable: true,
          value: "country_code"
        },
         {
          text: "City",
          align: "left",
          sortable: true,
          value: "city"
        },
         {
          text: "Code (EMN)",
          align: "left",
          sortable: true,
          value: "code"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      filters: {
        name: {
          type: 'text',
          value: undefined,
          replace: "%VALUE%",
          placeholder: 'Search'
        },
        country_code: {
          type: 'text',
          value: undefined,
          replace: "VALUE",
          placeholder: 'Search'
        },
        city: {
          type: 'text',
          value: undefined,
          replace: "VALUE%",
          placeholder: 'Search'
        },
        code: {
          type: 'text',
          value: undefined,
          replace: "%VALUE%",
          placeholder: 'Search'
        },
      },
      sites: []
    };
  },
  watch: {
    pagination: {
      handler(val, oldVal) {
        if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||  
          val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
          this.getData();
        }
      },
      deep: true
    },
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", true);
  },
  mounted() {
    this.getData();
    this.$root.$on('updateSites', () => {
     this.getData();
    });
  },
  computed: {
  },
  methods: {
    openAuditTrail (item) {
      this.auditTrail.entityId = item.id
      this.auditTrail.open = true
    },
    getData() {
      this.loading = true;
      getList(normalizeFilters(this.filters), this.pagination).then(data => {
        this.sites = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalSites = data.tot;
        this.loading = false;
      });
    },
    changeSort(column) {
      const oldPagination = JSON.parse(JSON.stringify(this.pagination));
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = false;
      }
      this.pagination = oldPagination;
    },
    filterChanged(filter) {
      this.getData();
      console.log("Filter changed", filter)
    },
    upsertDialog(item = {}) {
      this.$store.dispatch(
        "app/openSiteDialog",
        JSON.parse(JSON.stringify(item))
      );
    },
    confirmDelete() {
      remove(this.siteItem.id).then( id => {
        this.getData();
        this.$store.dispatch("app/openSnackbar", {
          message: "Site deleted successfully",
          color: "success"
        });
      }).catch( errorData => {
        let message = errorData.response.data.message;
        if (message.search("foreign key constraint") ) {
           message = "This record has already been used and cannot be removed";
        }
        this.$store.dispatch("app/openSnackbar", {
          message: "Site Delete error : " +  message,
          color: "error"
        });
      });
    }
  }
};
</script>

<style lang="scss">
#site_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>